import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem, Stack, Alert } from '@mui/material';
import useAxios from 'utils/useAxios';

const FEEDBACK_TYPES = [
    { value: 'data_issue', label: 'Data Issue' },
    { value: 'suggestion', label: 'Suggestion' },
    { value: 'anomaly', label: 'Anomaly' }
];

export default function FeedbackDialog({ open, onClose }) {
    const axios = useAxios();
    const [type, setType] = React.useState('data_issue');
    const [message, setMessage] = React.useState('');
    const [submitting, setSubmitting] = React.useState(false);
    const [error, setError] = React.useState('');
    const [success, setSuccess] = React.useState(false);

    const pageUrl = typeof window !== 'undefined' ? window.location.pathname + window.location.search : '';

    const handleSubmit = async () => {
        setSubmitting(true);
        setError('');
        setSuccess(false);
        try {
            await axios.post('feedback/', {
                type,
                message,
                page_url: pageUrl
            });
            setSuccess(true);
            setMessage('');
        } catch (e) {
            setError('Failed to submit. Please try again.');
        } finally {
            setSubmitting(false);
        }
    };

    const handleClose = () => {
        setError('');
        setSuccess(false);
        onClose?.();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Send Feedback</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 1 }}>
                    {error && <Alert severity="error">{error}</Alert>}
                    {success && <Alert severity="success">Thanks! We received your feedback.</Alert>}
                    <TextField select label="Type" value={type} onChange={(e) => setType(e.target.value)} fullWidth>
                        {FEEDBACK_TYPES.map((opt) => (
                            <MenuItem key={opt.value} value={opt.value}>
                                {opt.label}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        label="Message"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        multiline
                        minRows={4}
                        fullWidth
                    />
                    <TextField label="Page" value={pageUrl} InputProps={{ readOnly: true }} fullWidth />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={submitting}>
                    Close
                </Button>
                <Button onClick={handleSubmit} variant="contained" disabled={submitting || !message.trim()}>
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
}
